
import {Component, Vue, Watch} from "vue-property-decorator";
import {ProgramPaths} from "@/enum/ProgramPaths";

/** B10: sekme günlerce açık kalabiliyor; tazeleme bu süreden sık olamaz. */
const YENIDEN_YUKLEME_ARALIGI_MS = 5 * 60 * 1000;

/**
 * Üst çubuktaki haciz önerisi rozeti (Ö1 kararının ikinci yarısı).
 *
 * Yalnız sayıyı gösterir; liste ve eylemler İşlemler sayfasındaki
 * `SorguOneriList` panelindedir. İkisi de `sorguOneri` store modülünden beslenir,
 * bu yüzden panelde "yok say" denen kart rozetten de anında düşer.
 */
@Component({})
export default class SorguOneriInfo extends Vue {
  /**
   * Throttle kilidi (B10). `null` iken tazelemeye izin var; dolarken 5 dakikalık
   * bekleme sürüyor demektir. `beforeDestroy`de temizlenir — App.vue oturum boyunca
   * tek kez mount olsa da testte/route değişiminde sarkan zamanlayıcı kalmasın.
   */
  private yenidenYuklemeZamanlayici: number | null = null;

  /** `document`e eklenen/çıkarılan dinleyiciyle aynı referans kalsın diye alan olarak tutulur. */
  private sekmeGorunurOlduDinleyici = () => this.sekmeGorunurOldu();

  /** Öneriler e-İcrapro'ya özgü; diğer ürünlerin üst çubuğunda yer kaplamasın. */
  get gorunur(): boolean {
    return this.$route.path.startsWith(ProgramPaths.eicrapro);
  }

  get oneriSayisi(): number {
    return this.$store.getters["sorguOneri/oneriSayisi"];
  }

  get yuksekOncelikliSayisi(): number {
    return this.$store.getters["sorguOneri/yuksekOncelikliSayisi"];
  }

  get ipucu(): string {
    if (this.oneriSayisi === 0) return "Açık haciz önerisi yok";
    if (this.yuksekOncelikliSayisi > 0) {
      return this.oneriSayisi + " haciz önerisi (" + this.yuksekOncelikliSayisi + " yüksek öncelikli)";
    }
    return this.oneriSayisi + " haciz önerisi";
  }

  mounted() {
    this.yukleGerekiyorsa();
    document.addEventListener("visibilitychange", this.sekmeGorunurOlduDinleyici);
  }

  beforeDestroy() {
    document.removeEventListener("visibilitychange", this.sekmeGorunurOlduDinleyici);
    if (this.yenidenYuklemeZamanlayici !== null) {
      window.clearTimeout(this.yenidenYuklemeZamanlayici);
      this.yenidenYuklemeZamanlayici = null;
    }
  }

  /**
   * Uygulama kabuğu (App.vue) oturum boyunca TEK KEZ mount oluyor; bu bileşen de
   * onunla birlikte. Kullanıcı e-İcrapro dışında bir ürünle açılış yaparsa
   * `mounted` anında `gorunur` false olur ve rozet bir daha hiç yüklenmezdi.
   * e-İcrapro'ya ilk girişte yeniden denenir.
   */
  @Watch("$route")
  onRouteDegisti() {
    this.yukleGerekiyorsa();
  }

  /**
   * İlk denemeden sonra normal gezinmede tekrar istek atılmaz — liste zaten
   * paylaşımlı store'dan geliyor ve İşlemler sayfasındaki panel her açılışında
   * tazeliyor. `mounted`/route değişiminde İLK yüklemeyi garanti eden yol budur;
   * sonraki tazeleme B10 düzeltmesiyle tıklama ve sekme-görünürlük yollarından gelir.
   */
  yukleGerekiyorsa() {
    if (this.gorunur && !this.$store.getters["sorguOneri/oneriDenendiMi"]) {
      this.$store.dispatch("sorguOneri/yukle");
    }
  }

  /**
   * B10: rozet günlerce hiç tazelenmiyordu — kullanıcı sekmeyi açık bırakıp geri
   * döndüğünde (ör. gece nöbetçi haciz taraması) liste bayatlıyordu. Sekme görünür
   * olduğunda tazelenir, ama her odaklanmada uca gitmesin diye 5 dakikalık throttle var.
   */
  private sekmeGorunurOldu() {
    if (document.visibilityState !== "visible") return;
    if (!this.gorunur) return;
    if (this.yenidenYuklemeZamanlayici !== null) return;

    this.$store.dispatch("sorguOneri/yukle");
    this.yenidenYuklemeZamanlayici = window.setTimeout(() => {
      this.yenidenYuklemeZamanlayici = null;
    }, YENIDEN_YUKLEME_ARALIGI_MS);
  }

  /**
   * B10: eskiden yalnız ilk denemede istek atılıyordu, rozete tıklamak yüklemeyi
   * TETİKLEMİYORDU. Kullanıcı "elle yenile" niyetiyle rozete bastığında (İşlemler
   * sayfasına gitmeden önce bile) liste güncel olsun diye burada koşulsuz dispatch var.
   */
  onerilereGit() {
    this.$store.dispatch("sorguOneri/yukle");
    const hedef = ProgramPaths.eicrapro + "/islemler";
    if (this.$route.path !== hedef) {
      this.$router.push(hedef);
    }
  }
}
